import { theme, ThemeConfig } from "antd";
import tailwindConfig from "../tailwind.config";

const tailwindColors = tailwindConfig.theme!.extend!.colors as Record<
    string,
    any
>;

const antdTheme: ThemeConfig = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorPrimary: tailwindColors.primary.DEFAULT,
        colorText: tailwindColors.text.heading,
        borderRadius: 4,
        colorBgContainer: tailwindColors.secondary.white,
        controlHeight: 36,
        colorBorder: tailwindColors.secondary.gray[2],
    },
    components: {
        Divider: {
            colorSplit: "#E8E8E8",
        },
        Checkbox: {
            borderRadiusSM: 2,
            controlHeight: 14,
            lineWidth: 2,
        },
        Select: {
            paddingSM: 20,
            controlHeightLG: 50,
            controlHeight: 40,
            colorTextPlaceholder: tailwindColors.text.placeholder,
            colorText: tailwindColors.text.input,
            fontSize: 16,
            optionSelectedFontWeight: 400,
            optionSelectedColor: tailwindColors.primary.DEFAULT,
        },
        Steps: {
            colorPrimary: tailwindColors.primary.finance2,
            iconFontSize: 16,
        },
        Button: {
            paddingSM: 20,
            colorText: tailwindColors.text.detail,
        },
        TreeSelect: {
            colorBgBase: "red",
            colorBgContainer: tailwindColors.background.input,
        },
        Input: {
            colorText: tailwindColors.text.input,
            colorTextPlaceholder: tailwindColors.text.placeholder,
        },
        Segmented: {
            controlHeight: 30,
            colorBgBase: "red",
            colorBgMask: "red",
            colorBgSpotlight: "red",
            colorBgLayout: tailwindColors.background["elevated-highlight"],
        },
        Tabs: {
            colorPrimary: "black",
            colorBgContainer: tailwindColors.background.lightest,
        },
        Table: {
            colorText: tailwindColors.text.heading,
            colorBgContainer: "white",
            colorTextHeading: "black",
        },
    },
};

export default antdTheme;
